import type { Place } from '@/types';
import { api } from './api';

// The inventory's place hierarchy — the source for the disclosure's
// place-scope picker. A flat list (each place carries its `parents`
// links); the hierarchy is assembled at display time. Places are
// provisioned out-of-band and effectively static within a disclosure
// session, so a single inventory-keyed query with a `Places` tag is
// enough.
const placesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlaces: builder.query<Place[], number>({
      query: (inventoryId) => `inventories/${inventoryId}/places`,
      providesTags: ['Places'],
    }),
  }),
});

export const { useGetPlacesQuery } = placesApi;
